import { filter, map, prepend } from 'ramda';
import { Routine } from 'redux-saga-routines';
import { IApiToken } from '../../../../common/models/workspace/IApiToken';
import {
  createApiTokenRoutine,
  deactivateApiTokenRoutine,
  reactivateApiTokenRoutine,
  deleteApiTokenRoutine,
  getApiTokensRoutine,
  resetApiTokenRoutine
} from '../../routines';

export type ApiTokensState = {
  tokens?: IApiToken[];
  apiToken?: string;
};

const initialState: ApiTokensState = {};

export const apiTokens = (
  state: ApiTokensState = initialState,
  { type, payload }: Routine<any>
): ApiTokensState => {
  switch (type) {
    case getApiTokensRoutine.SUCCESS:
      return {
        ...state,
        tokens: payload
      };
    case createApiTokenRoutine.SUCCESS:
      return {
        ...state,
        apiToken: payload.apiToken,
        tokens: prepend({ name: payload.name, isActive: true }, state.tokens as IApiToken[])
      };
    case reactivateApiTokenRoutine.SUCCESS:
      return {
        ...state,
        tokens: map(token => (token.name === payload
          ? { name: token.name, isActive: true }
          : token), state.tokens as IApiToken[])
      };
    case deactivateApiTokenRoutine.SUCCESS:
      return {
        ...state,
        tokens: map(token => (token.name === payload
          ? { name: token.name, isActive: false }
          : token), state.tokens as IApiToken[])
      };
    case deleteApiTokenRoutine.SUCCESS:
      return {
        ...state,
        tokens: filter(({ name }) => name !== payload, state.tokens as IApiToken[])
      };
    case resetApiTokenRoutine.TRIGGER:
      return {
        ...state,
        apiToken: undefined
      };
    default:
      return state;
  }
};
